// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * SRM requests API service.
 */
import type { NodeApiClient } from '@/app-shell/services'

export interface RequestResponse {
  groupId: string
  title: string | null
  externalRef: string | null
  createdBy: string | null
  createdAt: string
  updatedAt: string
}

export interface RequestListResponse {
  requests: RequestResponse[]
  nextToken: string | null
  hasMore: boolean
  totalCount: number
}

/** List all requests in a workspace. */
export async function listRequests(
  apiClient: NodeApiClient,
  orgId: string,
  wsId: string,
  appPrefix: string = 'srm',
): Promise<RequestListResponse> {
  const url = `/org/${orgId}/ws/${wsId}/${appPrefix}/requests`
  const res = await apiClient.get<RequestListResponse>(url)
  return res.data
}

/** Delete a request and all its documents. */
export async function deleteRequest(
  apiClient: NodeApiClient,
  orgId: string,
  wsId: string,
  groupId: string,
  appPrefix: string = 'srm',
): Promise<void> {
  await apiClient.delete(`/org/${orgId}/ws/${wsId}/${appPrefix}/requests/${encodeURIComponent(groupId)}`)
}
